// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1131":"css/app.6981","5517":"css/admin-app.6981"}[chunkId] + ".css";
};